<template>
  <div class="list row">
    <div class="row">
      <div :class="superUser ? 'col-lg-4' : 'col-lg-6 col-xl-5'">
        <h4 v-if="superUser" class="col-xs-12 col-sm-4" style="display:inline-block;">
          {{ $t('common.issue') }}
        </h4>
        <h4 v-else class="col-xs-12 col-sm-4" style="display:inline-block;">
          {{ $t('issue.my_issue') }}
        </h4>
        <div class="search-wrapper float-right col-8">
          <input v-model="searchIssue" type="text" :placeholder="$t('common.quick_search')">
        </div>
      </div>
      <div class="row" :class="superUser ? 'col-lg-8' : 'col-lg-6 col-xl-7'">
        <div class="col-xs-12 col-sm-6 col-xl-5">
          <div class="input-group input-group-sm mb-1">
            <div class="input-group-prepend">
              <span class="input-group-text">  Ordenar Por </span>
            </div>
            <select v-model="sorting" class="custom-select">
              <option value="id:asc">
                Id Ascendente
              </option>
              <option value="id:des">
                Id Descendente
              </option>
              <option v-if="!customerUser" value="customer:asc">
                Cliente
              </option>
              <option v-if="!customerUser" value="priority:des">
                Prioridad
              </option>
            </select>
          </div>
        </div>
        <div class="col-3 col-sm-6">
          <button v-if="!customerUser" class="btn btn-info btn-vuvle mr-1" data-toggle="modal" data-target="#filters">
            {{ $t('action.filter') }}
          </button>
          <button class="btn btn-warning btn-vuvle" @click="togglePerformantIssues()">
            {{perfIssueStatus}}
          </button>
        </div>
      </div>
      <!-- <pagination v-show="inPagination" class="col-sm-12" :total="total" :page.sync="listQuery.page" :size.sync="listQuery.size" @pagination="getPaginatedList" /> -->
    </div>
    <div class="row issues-wrapper">
      <div class="col-lg-4">
        <ul class="ticketlist">
          <li v-for="(anIssue, index) in filteredIssues" :key="index" :class="setClass(anIssue)" @click="selectIssue(anIssue)">
            <div class="ticket-wrapper">
              #{{ getTicketId(anIssue) }} ({{ formatDate(anIssue.dateCreated) }}) - {{anIssue.customer.firstName}}
              <br>
              <font-awesome-icon icon="phone-alt" /> {{anIssue.customer.phone}} -
              <span v-if="anIssue.deviceBrand && anIssue.deviceBrand.length >= 30">{{anIssue.deviceBrand.substring(0, 29) + '...'}}</span>
              <span v-else>{{anIssue.deviceBrand}}</span>
              <br>
              <span :class="'badge float-left badge-' + statusClass(anIssue)">{{translateStatus(anIssue)}}</span>
              <span v-if="!anIssue.assignedTo && !customerUser" class="badge badge-pill badge-danger float-right mr-1">{{ $t('issue.none_assigned_to') }}</span>
              <span v-else-if="!customerUser" class="badge badge-pill badge-info float-right mr-1">{{anIssue.assignedTo.username}}</span>
            </div>
          </li>
        </ul>
      </div>

      <div class="issue-container col-lg-8">
        <issue ref="issueComponent" :issue="selectedIssue" :technicians="technicians" :is-customer="customerUser" :super-user="superUser" @refreshData="refreshList" @updateTicket="updateIssue" />
      </div>
    </div>
    <!-- Filters modal -->
    <div v-if="!customerUser" id="filters" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="modalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 id="modalLabel" class="modal-title">
              {{ $t('action.filter') }}
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="input-group input-group-sm mb-1">
              <div class="input-group-prepend">
                <span class="input-group-text">{{ $t('action.only_active') }}</span>
              </div>
              <div class="form-control">
                <input v-model="onlyActive" type="checkbox" @click="toggleIssues">
                <span class="d-none d-md-inline" style="font-size:14px;float:right;"> ← </span>
              </div>
            </div>
            <div class="input-group input-group-sm mb-1">
              <div class="input-group-prepend">
                <span class="input-group-text"> {{ $t('issue.status') }} </span>
              </div>
              <select v-model="statusFiltered" class="custom-select">
                <option value="all">
                  {{ $t('common.all') }}
                </option>
                <option :value="null">
                  Nuevo
                </option>
                <option v-for="(stObj, name) in status" :key="name" :value="stObj.id">
                  {{stObj.name}}
                </option>
              </select>
            </div>
            <div class="input-group input-group-sm mb-1">
              <div class="input-group-prepend">
                <!-- <span class="input-group-text">  {{ $t('issue.priority') }} </span> -->
                <span class="input-group-text"> Sucursal </span>
              </div>
              <select v-model="priorityFiltered" class="custom-select">
                <option value="all">
                  {{ $t('common.all') }}
                </option>
                <option value="">
                  <!-- Ninguna -->
                  Nueva Palmira
                </option>
                <option v-for="(stObj, name) in priorities" :key="name" :value="stObj.id">
                  {{stObj.name}}
                </option>
              </select>
            </div>
            <div v-if="superUser">
              <div class="input-group input-group-sm mb-1">
                <div class="input-group-prepend">
                  <span class="input-group-text"> {{ $t('sidebar.employees') }} </span>
                </div>
                <select v-model="techFiltered" class="custom-select">
                  <option value="all">
                    {{ $t('common.all') }}
                  </option>
                  <option v-for="(tech, name) in technicians" :key="name" :value="tech.username">
                    {{ tech.username | capitalize }}
                  </option>
                </select>
              </div>
            </div>
            <div class="input-group input-group-sm mb-1">
              <div class="input-group-prepend">
                <span class="input-group-text"> {{ $t('common.short_type') }} </span>
              </div>
              <select v-model="typeFiltered" class="custom-select">
                <option value="all">
                  {{ $t('common.all') }}
                </option>
                <option value="">
                  Smartdrone
                </option>
                <option value="Presupuesto">
                  Presupuesto
                </option>
                <option value="Sancor">
                  Sancor
                </option>
                <option value="Daferol">
                  Daferol
                </option>
                <option value="Termalesuy">
                  Termalesuy
                </option>
                <option value="AMV">
                  AMV
                </option>
                <option value="Zerisur">
                  Zerisur
                </option>
                <option value="PcService">
                  PcService
                </option>
              </select>
            </div>
            <div class="input-group input-group-sm mb-1">
              <div class="input-group-prepend">
                <span class="input-group-text"> Desde </span>
              </div>
              <input v-model="dateFiltered.from" type="date" class="form-control" placeholder="desde">
              <div class="input-group-prepend">
                <span class="input-group-text"> Hasta </span>
              </div>
              <input v-model="dateFiltered.to" type="date" class="form-control" placeholder="hasta">
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="removeFilters">
              {{ $t('action.remove_filter') }}
            </button>
            <button type="button" class="btn btn-primary" data-dismiss="modal">
              {{ $t('action.ok') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IssueService from '@/services/issue.service';
// import StatusService from '@/services/status.service';
import PriorityService from '@/services/priority.service';
import Issue from '@/views/issues/Issue';
// import UserService from '@/services/user.service';
import { getTicketId, formatDate } from '@/utils/page-utils';
// import { EventBus } from '@/utils/event.bus.js';
// import Pagination from '@/components/Pagination';

export default {
    name: 'IssueList',
    components: {
        Issue
    // , Pagination
    },
    filters: {
        capitalize: function capitalize(value) {
            var processVal = value;
            if (!processVal) {
                return '';
            }
            processVal = processVal.toString();
            return processVal.charAt(0).toUpperCase() + processVal.slice(1);
        }
    },
    props: {
        issue: Object
    },
    data() {
        return {
            perfIssueStatus: '6 meses',
            searchIssue: '',
            sorting: 'id:asc',
            statusFiltered: 'all',
            techFiltered: 'all',
            typeFiltered: 'all',
            priorityFiltered: 'all',
            dateFiltered: {},
            priorities: null,
            selectedIssue: {},
            // technicians: [],
            onlyActive: true,
            // pagination related properties
            listQuery: {
                page: this.$store.state.issues.issues.number + 1,
                size: 20
            }
        };
    },
    computed: {
        inPagination: {
            // getter
            get: function get() {
                return this.$store.state.issues.inpagination;
            },
            // setter
            set: function set(newValue) {
                this.$store.dispatch('issues/setPaginated', newValue);
                if (this.onlyActive && newValue) {
                    this.onlyActive = false;
                } else if (!this.onlyActive && !newValue) {
                    this.onlyActive = true;
                }

                this.refreshList();
            }
        },
        currentUser() {
            return this.$store.state.auth.user;
        },
        superUser() {
            return this.currentUser && (this.currentUser.roles.includes('ROLE_ADMIN') || this.currentUser.roles.includes('ROLE_MODERATOR'));
        },
        customerUser() {
            return !this.superUser && this.currentUser && !this.currentUser.roles.includes('ROLE_TECHNICIAN') && this.currentUser.roles.includes('ROLE_CUSTOMER');
        },
        technicians() {
            return this.$store.state.technicians.technicians;
        },
        status() {
            return this.$store.state.issues.status;
        },
        issues() {
            if (this.inPagination) {
                return this.$store.state.issues.issues.content;
            }
            return this.$store.state.issues.issues;
        },
        filteredIssues() {
            let retFilteredIssues;

            if (this.searchIssue || this.statusFiltered !== 'all' || this.techFiltered !== 'all' || this.typeFiltered !== 'all' ||
                this.priorityFiltered !== 'all' || this.dateFiltered.from
            ) {
                if (this.searchIssue) {
                    if (isNaN(this.searchIssue)) {
                        if (this.searchIssue.toLowerCase().includes('sku:')) {
                            const sku = this.searchIssue.toLowerCase().split('sku:')[1];
                            retFilteredIssues = this.issues.filter(issue => {
                                return issue.sku && issue.sku.toLowerCase().includes(sku);
                            });
                        } else {
                            retFilteredIssues = this.issues.filter(issue => {
                                return issue.deviceBrand && issue.deviceBrand.toLowerCase().includes(this.searchIssue.toLowerCase()) ||
                                    issue.customer.firstName.toLowerCase().includes(this.searchIssue.toLowerCase()) ||
                                    issue.serialNo && issue.serialNo.toLowerCase().includes(this.searchIssue.toLowerCase());
                            });
                        }
                    } else {
                        retFilteredIssues = this.issues.filter(issue => {
                            return issue.customer.phone.toLowerCase().includes(this.searchIssue.toLowerCase()) ||
                                issue.serialNo && issue.serialNo.toLowerCase().includes(this.searchIssue.toLowerCase());
                        });
                    }
                }

                if (!retFilteredIssues) {
                    retFilteredIssues = this.issues;
                }

                if (this.statusFiltered !== 'all') {

                    if (!this.statusFiltered) {
                        retFilteredIssues = retFilteredIssues.filter(issue => {
                            return !issue.status2;
                        });
                    } else {
                        retFilteredIssues = retFilteredIssues.filter(issue => {
                            return issue.status2 && issue.status2.id === this.statusFiltered;
                        });
                    }
                }

                if (this.priorityFiltered !== 'all') {
                    retFilteredIssues = retFilteredIssues.filter(issue => {
                        if (this.priorityFiltered === '') {
                            return !issue.priority;
                        }
                        return issue.priority && issue.priority.id === this.priorityFiltered;
                    });
                }

                if (this.techFiltered !== 'all') {

                    retFilteredIssues = retFilteredIssues.filter(issue => {
                        return issue.assignedTo && issue.assignedTo.username.toLowerCase() === this.techFiltered.toLowerCase();
                    });
                }

                if (this.typeFiltered !== 'all') {

                    retFilteredIssues = retFilteredIssues.filter(issue => {
                        if (this.typeFiltered === '') {
                            return !issue.issueType || issue.issueType.toLowerCase() === '';
                        }
                        return issue.issueType && issue.issueType.toLowerCase() === this.typeFiltered.toLowerCase();
                    });
                }
                retFilteredIssues = this.filterDate(retFilteredIssues);

                return this.sortResults(retFilteredIssues);
            }
            return this.sortResults(this.issues);
        },
        total() {
            if (this.$store.state.issues.loading) {
                return 0;
            }
            if (this.inPagination) {
                return this.$store.state.issues.issues.totalElements;
            }
            return this.$store.state.issues.issues.length;
        }
    },
    created() {
        var self = this;
        // EventBus.$on('internalSearch', issueSelected => {
        //     // no coexisten las posibilidades de cargar desde paginas y buscar algo a la vez.
        //     var interval, i;
        //     this.$store.dispatch('issues/setPaginated', false);
        //     this.onlyActive = false;
        //     // this.refreshList();
        //     this.$store.dispatch('issues/getIssues');
        //     i = 0;
        //     interval = setInterval(function tryToSelect() {
        //         if (!self.$store.state.issues.loading) {
        //             self.selectIssue(issueSelected);
        //             clearInterval(interval);
        //         } else if (i > 1000) {
        //             clearInterval(interval);
        //             console.error('Limpiamos intervalo, algo malo está sucediendo...');
        //         }
        //         i++;
        //     }, 1);
        // });

        if (this.issue) {
            setTimeout(function waitATick() {
                self.selectIssue(self.issue);
            }, 1);
        }

        // When issues come from a search, it wont have a relation with the list.
        this.refreshList();
    },
    methods: {
    /* eslint-disable no-console */
        filterDate(issues) {
            let fromDate, toDate, tempDate;
            let filteredResult = issues;

            if (this.dateFiltered.from || this.dateFiltered.to) {
                if (!this.dateFiltered.from) {
                    this.dateFiltered.from = new Date().toISOString().substr(0, 10);
                }
                if (!this.dateFiltered.to) {
                    this.dateFiltered.to = new Date().toISOString().substr(0, 10);
                }

                fromDate = new Date(this.dateFiltered.from).getTime();
                toDate = new Date(this.dateFiltered.to).getTime();

                if (fromDate > toDate) {
                    tempDate = this.dateFiltered.to;
                    this.dateFiltered.to = this.dateFiltered.from;
                    this.dateFiltered.from = tempDate;

                    fromDate = new Date(this.dateFiltered.from).getTime();
                    toDate = new Date(this.dateFiltered.to).getTime();
                }

                filteredResult = filteredResult.filter(issue => {
                    const issueDate = new Date(issue.dateCreated.split('T')[0]).getTime();

                    return issueDate && fromDate <= issueDate && toDate >= issueDate;
                });
            }
            return filteredResult;
        },
        sortResults(issues) {
            let sortedResults = issues;
            if (this.sorting === 'id:asc') {
                sortedResults.sort((a, b) => a.id - b.id);
            } else
            if (this.sorting === 'id:des') {
                sortedResults.sort((a, b) => b.id - a.id);
            } else if (this.sorting === 'customer:asc') {
                sortedResults.sort((a, b) => {
                    const customerNameA = a.customer.firstName.toUpperCase();
                    const customerNameB = b.customer.firstName.toUpperCase();
                    if (customerNameA < customerNameB) {
                        return -1;
                    } else
                    if (customerNameA > customerNameB) {
                        return 1;
                    }

                    return 0;
                });
            } else if (this.sorting === 'priority:des') {
                sortedResults.sort((a, b) => {
                    const priorityA = a.priority;
                    const priorityB = b.priority;

                    if (priorityA && priorityB) {
                        return priorityA.sequence - priorityB.sequence;
                    } else if (priorityB) {
                        return 1;
                    } else if (priorityA) {
                        return -1;
                    }
                    return 0;
                });
            }
            return sortedResults;
        },
        selectIssue(issue) {
            var self = this;
            if (this.issues) {
                // cleaning because of duplicates.
                this.issues.forEach(anIssue => {
                    delete anIssue.class;
                });
            }
            this.selectedIssue = this.issues.filter(askIssue => askIssue.id === issue.id)[0];

            if (this.selectedIssue) {
                IssueService.getData(this.selectedIssue.id).then(
                    response => {
                        this.selectedIssue = response.data;
                        this.$refs.issueComponent.initIssueComponent(this.selectedIssue);
                    },
                    error => {
                        console.log(error.response && error.response.data ||
                  error.message || error.toString());
                    }
                );

                // this.$refs.issueComponent.initIssueComponent();
                this.selectedIssue.class = 'selected';
            }
        },
        translateStatus(issue) {
            var active = issue.active;
            var status = issue.status;
            var status2 = issue.status2;
            if (!active) {
                return 'Cerrado';
            }
            if (!status2) {
                return 'Nuevo';
            }
            return status2.name;
        },
        statusClass(issue) {
            var retVal = 'primary';
            var triggersStr, triggerActions;
            if (issue.status2 && issue.status2.triggers) {
                triggersStr = '{' + issue.status2.triggers + '}';
                try {
                    triggerActions = JSON.parse(triggersStr);

                    if (triggerActions.className) {
                        retVal = triggerActions.className;
                    }
                } catch (e) {
                    console.log(e);
                }
            }

            if (!issue.active) {
                return 'dark';
            }
            if (retVal === 'primary') {
                // if primary still there, means that status2 is not giving any classname.
                if (issue.status === 'WaitingForCustomer' || issue.status === 'NotRepaired') {
                    retVal = 'warning';
                } else if (issue.status === 'Repaired') {
                    retVal = 'success';
                }
            }
            return retVal;
        },
        setClass(issue) {
            var retVal = '';
            var triggersStr, triggerActions;

            if (issue.class) {
                retVal = issue.class + ' ';
            }

            if (!issue.active) {
                return retVal + 'dark';
            } else
            if (!issue.assignedTo) {
                retVal += 'danger';
            }

            if (issue.priority) {
                // as we are running through all the issues here, we could check those with technical alerts.
                // if (issue.priority.type === 'ALERT' && this.currentUser.roles.includes('ROLE_ADMIN') && !issue.triggered &&
                //     (!issue.class || issue.class && issue.class.includes('selected'))
                // ) {
                //     if (!issue.toast) {
                //         issue.toast = true;
                //     } else {
                //         if (issue.class && issue.class.includes('selected')) {
                //             issue.triggered = true;
                //         }
                //         issue.toast = false;
                //     }
                // }

                if (issue.priority.triggers) {
                    triggersStr = '{' + issue.priority.triggers + '}';
                    try {
                        triggerActions = JSON.parse(triggersStr);

                        if (triggerActions.className) {
                            retVal += ' tag-' + triggerActions.className + ' ';
                        }
                    } catch (e) {
                        console.log(e);
                    }
                }
            }

            if (issue.status2) {
                if (issue.status2.triggers) {

                    triggersStr = '{' + issue.status2.triggers + '}';
                    try {
                        triggerActions = JSON.parse(triggersStr);

                        if (triggerActions.className) {
                            retVal += triggerActions.className;
                        }
                    } catch (e) {
                        console.log(e);
                    }
                } else {
                    retVal += 'primary';
                }
            } else
            if (issue.status === 'WaitingForCustomer' || issue.status === 'NotRepaired') {
                retVal += 'warning';
            } else
            if (issue.status === 'Repaired') {
                retVal += 'success';
            }

            if (retVal === '' || issue.class && retVal === issue.class + ' ') {
                retVal += 'primary';
            }

            return retVal;
        },
        getTicketId,
        formatDate,
        getPaginatedList() {
            this.refreshList();
        },
        removeFilters() {
            this.statusFiltered = 'all';
            this.techFiltered = 'all';
            this.typeFiltered = 'all';
            this.priorityFiltered = 'all';
            this.dateFiltered = {};
        },
        refreshList(forceOnlyActive) {
            const forceOnlyActiveRequest = forceOnlyActive === 'forceOnlyActive';
            // get Statuses if null.
            // if (!this.status) {
            //     StatusService.getStatus(true).then(
            //         response => {
            //             this.status = response.data;
            //         },
            //         error => {
            //             console.log(error.response && error.response.data ||
            //           error.message || error.toString());
            //         }
            //     );
            // }
            // get Priorities if null. Not needed now.
            if (!this.priorities) {
                PriorityService.getPriorities(true).then(
                    response => {
                        this.priorities = response.data;
                    },
                    error => {
                        console.log(error.response && error.response.data ||
                      error.message || error.toString());
                    }
                );
            }
            if (!this.$store.state.issues.status || !this.$store.state.issues.status.length) {
                this.$store.dispatch('issues/getStatus');
            }
            if (!this.$store.state.technicians.technicians || !this.$store.state.technicians.technicians.length) {
                this.$store.dispatch('technicians/getTechnicians');
            }
            // this.$store.dispatch('issues/getIssueFields');

            if (this.superUser && this.inPagination) {
                this.$store.dispatch('issues/getPaginatedIssues', this.listQuery);
            } else if (this.customerUser) {
                // customer Behaviour.
                this.$store.dispatch('issues/getCustomerIssues', this.currentUser.email);
            } else if (!this.$store.state.issues.issues.length || forceOnlyActiveRequest) {
                this.$store.dispatch('issues/getPerformantIssues');
            }
        },
        toggleIssues() {
            // technical staff has access to other places.
            if (!this.superUser) {
                if (this.customerUser) {
                    this.$store.dispatch('issues/getCustomerIssues', this.currentUser.email);
                } else
                if (this.onlyActive) {
                    this.$store.dispatch('issues/getIssues');
                } else {
                    this.$store.dispatch('issues/getPerformantIssues');
                }
                return;
            }
            // super users can check many things
            if (!this.onlyActive) {
                this.$store.dispatch('issues/setPaginated', false);
                this.refreshList('forceOnlyActive');
            } else {
                this.$store.dispatch('issues/getIssues');
            }
        },
        togglePerformantIssues() {
            if (this.perfIssueStatus === '6 meses') {
                this.perfIssueStatus = 'Mostrando sin limite';
                this.$store.dispatch('issues/getActiveIssues');
            } else {
                this.perfIssueStatus = '6 meses';
                this.$store.dispatch('issues/getPerformantIssues');
            }
        },
        updateIssue(issue) {
            if (issue.id === this.selectedIssue.id) {
                this.selectedIssue = issue;
            }
            this.$store.dispatch('issues/updateIssue', issue);
        }
    /* eslint-enable no-console */
    }
};
</script>

<style lang="scss">
$danger: #DC3545;
$warning: #FFC107;
$success: #28A745;
$primary: #007BFF;
$secondary: #6C757D;
$info: #17A2B8;

.row.list {
  text-align: left;
  margin-left: 0;
  margin-right: 0;
  > .row {
    width: 100%;
    margin-left: 0;
    margin-right: 0;
  }
}
.ticketlist > li {
    font-size: 14px;
    border: 1px solid #EEE;
    border-radius: 5px;
    overflow: hidden;
    margin-bottom: 5px;
    padding: 5px;
    position: relative;
    cursor: pointer;
    .ticket-wrapper {
        width: calc(100% - 20px);
    }
    &:after {
        content: ' ';
        position: absolute;
        width: 25px;
        height: 100%;
        right: 0;
        top: 0;
        border-left: 1px solid #EEE;
    }
    &.dark:after {
        background-color: #000;
    }
    &.danger:after {
        background-color: $danger;
    }
    &.warning:after {
        background-color: $warning;
    }
    &.success:after {
        background-color: $success;
    }
    &.primary:after {
        background-color: $primary;
    }
    &.secondary:after {
        background-color: $secondary;
    }
    &.info:after {
        background-color: $info;
    }
    &.selected {
        background-color: #FAFAFA;
        border-color: #AAA;
    }

    // Priority tags
    &.tag {
        &-danger {
            background-color: rgba($danger, 0.25);
        }
        &-warning {
            background-color: rgba($warning, 0.25);
        }
        &-success {
            background-color: rgba($success, 0.25);
        }
        &-primary {
            background-color: rgba($primary, 0.25);
        }
        &-secondary {
            background-color: rgba($secondary, 0.25);
        }
        &-info {
            background-color: rgba($info, 0.25);
        }

    }
}
.selected {
     border: 1px solid blue;
}
.ticketlist {
    padding-left: 0;
    list-style: none;
    max-height: 85vh;
    overflow-y: auto;
}
.badge-pill.badge-danger {
    margin-left: 5px;
}
.search-wrapper {
  position: relative;
  padding-right: 5px;
  input {
      box-shadow: none;
      font-size: 12px;
      width: 100%;
      border: 1px solid #CACACA;
      border-radius: 5px;
    &:focus {
        border-bottom: 2px solid #CACACA;
        border-right: 2px solid #CACACA;
        outline: none;
    }
  }
}
.btn-vuvle {
    line-height: 1.1;
}
@media (max-width: 600px) {
    .issue-container, .issues-wrapper {
        padding: 0;
    }
}
</style>
